const { SIMILAR_TIMEZONE_FILTER_ID } = require('./constants');

// Explicit seller_location picks are added to the tz-derived countries, never intersected with them.
const computeEffectiveLocations = (explicitLocations, tzCountries) =>
    explicitLocations.length ? [...new Set([...explicitLocations, ...tzCountries])] : tzCountries;

const getUtcOffsetInMinutes = (date) => 0 - date.getTimezoneOffset();

// timezoneCountries.ts is keyed by standard-time offsets, so the lookup must ignore daylight saving.
// Standard time is the smaller of the winter and summer offsets (also true south of the equator).
const getStandardUtcOffsetInMinutes = (now = new Date()) => {
    const year = now.getFullYear();

    return Math.min(getUtcOffsetInMinutes(new Date(year, 0, 1)), getUtcOffsetInMinutes(new Date(year, 6, 1)));
};

// The value is a UTC offset in minutes, so 0 is active: check the type, not truthiness.
const isSimilarTimezoneActive = (activeFilters) => typeof activeFilters?.[SIMILAR_TIMEZONE_FILTER_ID] === 'number';

module.exports = {
    getStandardUtcOffsetInMinutes,
    computeEffectiveLocations,
    isSimilarTimezoneActive,
};
